import { useEffect, useState } from "react";

import { Button, Modal, Form, Input, message, Select } from "antd";

import useCompanies from "../hooks/useCompanies";
import useUsers from "../hooks/useUsers.js";

function CoordinatorFormModal({ onCreate, company, disabled }) {
  const { getCompanies } = useCompanies();
  const { loading, createCoordinator } = useUsers();

  const [form] = Form.useForm();

  const [open, setOpen] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    getCompanies();
  }, []);

  async function submitForm() {
    try {
      const values = await form.validateFields();

      const finalValues = {
        ...values,
        company: company.value,
      };

      const coordinator = await createCoordinator(finalValues);

      setOpen(false);

      onCreate(coordinator);
    } catch {
      message.warning("Formulario invalido");
    }
  }

  function handleFormChange() {
    setTimeout(() => {
      form
        .validateFields({ validateOnly: true })
        .then(() => {
          setIsFormValid(true);
        })
        .catch(() => {
          setIsFormValid(false);
        });
    }, 300);
  }

  return (
    <>
      <Button
        className="ms-3"
        onClick={() => setOpen(true)}
        disabled={disabled}
      >
        Crear coordinador
      </Button>

      <Modal
        open={open}
        onOk={submitForm}
        okText="Crear Coordinador"
        cancelText="Cancelar"
        okButtonProps={{ disabled: !isFormValid }}
        title="Creación rápida de coordinador"
        confirmLoading={loading.post}
        onCancel={() => {
          setOpen(false);
        }}
        afterClose={() => {
          form.resetFields();
        }} // Ensure form reset after modal is fully closed
      >
        <Form
          form={form}
          layout="vertical"
          onFieldsChange={handleFormChange}
          className="mt-5"
        >
          <div style={{ display: "flex", gap: "16px" }}>
            <Form.Item
              name="firstName"
              label="Nombre"
              rules={[
                { required: true, message: "Por favor ingresa un nombre." },
              ]}
              style={{ flex: 1 }}
            >
              <Input />
            </Form.Item>

            <Form.Item name="lastName" label="Apellido" style={{ flex: 1 }}>
              <Input />
            </Form.Item>
          </div>

          <Form.Item
            name="phoneNumber"
            label="Número de Teléfono"
            rules={[
              { required: false, message: "Please enter the phone number" },
            ]}
          >
            <Input placeholder="+549 " />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default CoordinatorFormModal;
